var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":_vm.action,"on-success":_vm.success,"on-error":_vm.uploadError,"before-upload":_vm.beforeUpload,"file-list":_vm.fileList,"headers":_vm.headers}},[_c('el-button',{staticClass:"set-enclosure",attrs:{"size":"small","icon":_vm.icon,"type":_vm.type}},[_vm._t("ButtonName")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }